<!--<ng-container [ngTemplateOutlet]="step.stepLabel.template"></ng-container>-->

<ul class="nav-section-items">
  @for (step of _steps; track step; let i = $index) {
    @if (step.computedStep?.config.isTitle) {
      <h6 class="nav-section-title"
        [innerHtml]='$safeNavigationMigration(step.computedStep?.title)'
      ></h6>
    }
    @if (!step.computedStep?.config.isTitle) {
      <li
        class="nav-item nav-section-title"
        [ngClass]="{'active': selectedIndex === i, 'disabled': !step.computedStep.completed}"
        (click)="onClick(step, i)">
        {{step.computedStep.title}}
        @if (stepService.isCompleted($safeNavigationMigration(step.computedStep.config?.id))) {
          <span class="material-icons">done</span>
        }
      </li>
    }
  }
</ul>